import { connect } from 'react-redux';

import PromoBanner from '../../../components/account/PromoBanner';

const mapDispatchToProps = {};

function mapStateToProps(state) {
  return {
    product: state.getIn(['application', 'product']),
    casinoPromotions: state.getIn(['promotions', 'main', 'casinoPromotions']),
    exchangePromotions: state.getIn(['promotions', 'main', 'exchangePromotions']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PromoBanner);
